<template>
  <section>
    <div class="grid_gallery">
      <div class="grid_gallery__items">
        <div v-for="(photo, index) in photos"
             :key="photo.id"
             @click.prevent="onSlideClick(index)"
             class="grid_gallery__item">

          <img :src="photo.image"
               alt="Classic Family"
               class="grid_gallery__photo"
          >
          <div class="grid_gallery__overlay">
            <i class="eti eti_plus"></i>
          </div>
        </div>

      </div>
    </div>

    <LightBox :items="clearPhotosArray"
              :index="index"
              @close="onSlideClick(null)"/>
  </section>
</template>

<script>
import LightBox from '../components/LightBox'

export default {
  name: 'GridGallery',
  components: {
    LightBox
  },
  props: {
    photos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      swiper: null,
      index: null,
    }
  },
  computed: {
    clearPhotosArray() {
      return this.photos.map(item => item.image)
    }
  },
  methods: {
    onSlideClick(index) {
      this.index = index
    },
  },
  watch: {
    carousel() {
      this.update()
    }
  }
}
</script>

<style>

</style>
